import React from "react";
import classNames from "classnames";
import useTranslate from "../../../../modules/local/useTranslate";
import {useToggle} from "react-use";
import {BsCaretDownFill, BsCaretUpFill} from "react-icons/bs";

export const WrapperBlockSider = ({
    icon,
    title,
    children,
    titleColor = 'text-color-000',
    expanded = false,
    borderColorClass,
    borderTop, borderRight, borderBottom, borderLeft,
    flat = false,
}) => {

    const t = useTranslate()
    const [isToggle, toggle] = useToggle()

    // Border accent mặc định khớp màu với titleColor (thay vì luôn dùng 1 màu cố định)
    const accentBorderClass = borderColorClass || titleColor.replace('text-', 'border-')

    return !!children && (
        <div
            // style={
            //     flat
            //         ? {}
            //         : {boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)'}
            // }
            className={classNames(
                "flex flex-col w-full",
                flat ? "background-50 border border-color-50 rounded-2xl" : "border border-color-50 background shadow-sm rounded-2xl",
                borderTop && `border-t-2 ${accentBorderClass}`,
                borderRight && `border-r-2 ${accentBorderClass}`,
                borderBottom && `border-b-2 ${accentBorderClass}`,
                borderLeft && `border-l-2 ${accentBorderClass}`,
            )}>
            <h3 className="p-3 flex items-center gap-2">
                {icon}
                <span
                    className={classNames(
                        "flex-1 leading-snug text-lg font-bold tracking-wide",
                        titleColor
                    )}>
                    {t(title)}
                </span>
                {expanded === true && (
                    isToggle ? <BsCaretUpFill onClick={() => toggle()} size={14} className="text-primary"/> :
                        <BsCaretDownFill onClick={() => toggle()} size={14} className={titleColor}/>
                )}
            </h3>
            {expanded === true ? (isToggle && children) : children}
        </div>
    )
}
